export default __webpack_public_path__ + "static/media/background.d8ac8cd8.svg";